module.exports = __webpack_public_path__ + "img/owj-coupon-3000.1443d607.png";